<script setup lang="ts">
import KBtn from '@/components/btns/KBtn.vue';

export interface Props {
  isAsc?: boolean;
  isActive?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  isAsc: false,
  isActive: false,
});
</script>

<template>
  <KBtn
    :class="[$style.tableSortBtn, { [$style.active]: props.isActive }]"
    data-testid="tableSortBtn"
    variant="text"
    :icon="props.isAsc ? 'mdi-arrow-up' : 'mdi-arrow-down'"
    rounded="50"
    priority="text"
    size="xs"
  />
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.tableSortBtn {
  opacity: 0.2;

  :global {
    .v-icon {
    }
  }
}
.tableSortBtn.active {
  opacity: 1;
}
</style>
